/**
 *    @author:
 *    @since:
 *
 */

import { IValidator } from '../_common/component/IValidator';
import { Transition1Component} from './transition_1.component';

export class Transition1Validation extends IValidator {

       constructor(private component: Transition1Component) { super(); }

       private success: boolean;

       public validate(): boolean {

            this.success = true;

            // add your valdation here!

            return this.success;

       }
}

